<template>
  <div id="app">
    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">Borçlu Listesi</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
            <v-menu offset-y>
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>

                <v-list-tile @click="getListHtml()">
                  <v-list-tile-title>Html İndir</v-list-tile-title>
                </v-list-tile>


                <v-list-tile @click="getListExcel()">
                  <v-list-tile-title>Excel İndir</v-list-tile-title>
                </v-list-tile>

              </v-list>
            </v-menu>

          </v-toolbar>
        </v-flex>

        <v-container fluid>
          <v-layout row wrap>



              <v-flex xs12 sm6 md6 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">add_comment</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md12>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                   {{grandDebt}} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold"> Borç Genel Toplamı</span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


              <v-flex xs12 sm6 md6 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">cached</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md12>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{dueDebt}} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold">Vadesi Gelen Borç Toplamı</span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


          </v-layout>
        </v-container>

        <v-container fluid>
          <v-card color="grey lighten-5" flat>
            <v-layout row wrap>

              <v-flex xs12 sm6 md2>
                     <v-form ref="formtarih" v-model="valid" lazy-validation>

               <tarihcomp :etiket="'Tarih Seçiniz'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="date" v-model="date"></tarihcomp>
                     </v-form>
              </v-flex>

              <v-flex>
                <v-layout>
                  <div v-if="load1">
                    <v-btn color="info" @click="getList()" fab small="" dark>
                      <v-icon>search</v-icon>
                    </v-btn>
                  </div>
                  <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                    color="info" fab dark>
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                  <v-tooltip bottom="" :activator="el" v-model="tooltip">
                    <span>Arama Filtresi Ekle</span>
                  </v-tooltip>
                </v-layout>
              </v-flex>

              <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="800px">
                <v-card color="grey lighten-5">

                  <v-card-title>Filtre Seçimi</v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-layout row="" wrap="">

                      <v-flex pa-1 xs12 sm6 md6>
                        <v-card>
                          <v-card color="grey lighten-5" flat="">
                            <v-card-actions>


                        <v-layout justify-space-between column>
                          <v-autocomplete label="Başlangıç Cari Seçiniz" hide-details clearable :loading="loading1" append-icon="search"
                            :items="statecari" item-text="text" cache-items="" item-value="id" v-model="Borc.BaslangicCariKod"
                            :search-input.sync="search"></v-autocomplete>

                          <v-autocomplete label="Bitiş Cari Seçiniz" clearable hide-details :loading="loading2" append-icon="search"
                            :items="statecari2" item-text="text" cache-items="" item-value="id" v-model="Borc.BitisCariKod"
                            :search-input.sync="search1"></v-autocomplete>
                        </v-layout>
</v-card-actions>
                          </v-card>
                        </v-card>
                      </v-flex>

                     <v-flex pa-1 xs12 sm6 md6>
                        <v-card>
                          <v-card color="grey lighten-5" flat="">
                            <v-card-actions>


                        <v-layout justify-space-between column>
                          <v-select :items="masrafmerkezi" hide-details="" label="Masraf Merkezi" v-model="Borc.Masraf" item-text="CodeName"
                            clearable item-value="Code" max-height="400"></v-select>
                          <v-select :items="Referans" hide-details="" label="Referans" v-model="Borc.Referans" item-text="ReferansAd"
                            item-value="Kod" max-height="400"></v-select>
                        </v-layout>


                     </v-card-actions>
                          </v-card>
                        </v-card>
                      </v-flex>

                       <v-flex pa-1 xs12 sm12 md12>
                        <v-card flat="" color="#9E9E9E">
                          <v-card-title>
                            <span class="subheading white--text font-weight-medium "> Seçenekler</span>
                          </v-card-title>
                        </v-card>
                      </v-flex>

                      <v-flex xs12 sm12 md6>
                        <v-layout justify-space-between column>
                          <v-radio-group v-model="Borc.Sira" label="Sıra" column>
                            <v-radio label="Kod Sırası"  value='0'></v-radio>
                            <v-radio label="İsim Sırası"  value='1'></v-radio>
                          </v-radio-group>
                          <v-checkbox v-model="Borc.VadeCheck" label="İleri Vadeli Öd./Tah. Dahil Et." hide-details=""></v-checkbox>
                          <v-checkbox v-model="Borc.TsNofat" label="Coper Faturalanmamış Kayıtları Gösterme"
                            hide-details=""></v-checkbox>
                          <v-checkbox v-model="Borc.BirCheck" label="1 TL altındakileri Göster" hide-details=""></v-checkbox>
                          <v-checkbox v-model="Borc.TelVadeCheck" label="Tel ve Vade Bilgilerini Göster" hide-details=""></v-checkbox>
                          <v-checkbox v-model="tumsirketler" label="Tüm Şirketler" hide-details=""></v-checkbox>
                        </v-layout>
                      </v-flex>

                      <v-flex xs12 sm12 md3>
                        <v-layout justify-space-between column>
                          <v-radio-group v-model="Borc.ProgramDetay" label="" column>
                            <v-radio label="Tümü"  value='0'> </v-radio>
                            <v-radio label="Bilet" value='1'></v-radio>
                            <v-radio label="Serbest"  value='2'></v-radio>
                            <v-radio label="Coper "  value='3'></v-radio>
                          </v-radio-group>
                        </v-layout>
                      </v-flex>

                      <v-flex xs12 sm12 md3>
                        <v-layout justify-space-between column>
                          <v-radio-group v-model="Borc.Tip" label="" column>
                            <v-radio label="Tümü"  value='0'> </v-radio>
                            <v-radio label="Borçlu Listesi" value='1'></v-radio>
                            <v-radio label="Alacaklı listesi"  value='2'></v-radio>
                          </v-radio-group>
                          <v-radio-group v-model="Borc.ProgramTip" label="" column>
                            <v-radio label="Tümü"  value='0'> </v-radio>
                            <v-radio label="Sadece Coper"  value='1'></v-radio>
                            <v-radio label="Coper Hariç"  value='2'></v-radio>
                          </v-radio-group>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                    <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Filtreleri Uygula</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

               <v-flex xs12 sm12 md12>

                <v-card>

                  <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
                    :search="search3">
                    <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                    <template slot="items" slot-scope="props">

                      <tr @click="git(props.item.Account+'-'+props.item.Date+'-'+ props.item.Id)" item>
                        <td class="text-xs-left">{{ props.item.CurrentCode }}</td>
                        <td class="text-xs-left">{{ props.item.CurrentTitle }}</td>
                        <td class="text-xs-left">{{ props.item.Phone }}</td>
                        <td class="text-xs-left">{{ props.item.Email }}</td>
                        <td class="text-xs-right">{{ props.item.TotalDebt | moneyformat }}</td>
                        <td class="text-xs-right">{{ props.item.TotalDebtDue | moneyformat }}</td>
                      </tr>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                      Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                    </v-alert>
                  </v-data-table>
                </v-card>

                <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
                  :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                  {{ text1 }}
                  <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                </v-snackbar>
              </v-flex>

            </v-layout>
          </v-card>
        </v-container>

      </v-layout>
    </v-card>
  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import tarihcomp from "@/components/app/customcomp/tarihim"


  export default {
    data() {
      return {
        search: '',
        headers: [{
            text: 'Cari Hesap Kodu',
            value: 'CurrentCode'
          },
          {
            text: 'Ünvan ',
            value: 'CurrentTitle'
          },
          {
            text: 'Telefon',
            value: 'Phone'
          },
          {
            text: 'Email',
            value: 'Email'
          },
          {
            text: 'Toplam Borç',
            value: 'TotalDebt',
            align: 'right'
          },
          {
            text: 'Vadesi Gelen Borç',
            value: 'TotalDebtDue',
            align: 'right'
          }

        ],
        valid:true,
        Borc: {
          SirketKodu: '',
          Tarih: '',
          Masraf: '',
          Referans: '',
          TsNofat: '',
          VadeCheck: '',
          Tip: '0',
          BirCheck: '',
          TelVadeCheck: '',
          Sira: '0',
          ProgramTip: '0',
          ProgramDetay: '0'
        },
        tumsirketler: '',
        StartDate: null,
        EndDate: null,
        grandDebt: 0,
        dueDebt: 0,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        loading1: false,
        loading2: false,
        loading3: false,
        statecari: [],
        statecari2: [],
        items: [],
        search1: '',
        search3: '',
        load: false,
        load1: true,
        butondurum: true,



        dialogfiltre: false,
        hesapkodu: [],
        Referans: [],
        masrafmerkezi: [],
        anahesap: [],
        renk1: 'info',
        a: '',
        b: '',
        c: '',
        d: '',
        progress: false,


        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        tooltip: false,
        el: null,
        dictionary: {
          custom: {

            tarihsec: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsec1: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },
      }
    },
    beforeMount: beforeMount,
     components: {
      tarihcomp
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

    },

    watch: {
      search(val) {
        val && this.carigetir(val)
      },
      search1(val2) {
        val2 && this.carigetir1(val2)
      }

    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },
    methods: {



      carigetir: carigetir,
      carigetir1: carigetir1,
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      karsidegeral: karsidegeral,
      onChangecheck: onChangecheck
    }
  }


  function karsidegeral(val) {
    if (val === true) {
      return false
    } else {
      return true
    }
  }

  function onChangecheck(elem1, elem2) {

    if (this.a === true && elem2 == 'a') {
      this.b = karsidegeral(this.a)
    }

    if (this.b === true && elem2 == 'b') {
      this.a = karsidegeral(this.b)
    }
  }



  function filtrele() {

    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }


    this.$http.post(auth.API_URL + 'api/Reference/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.Referans = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.Borc.Referans = null


    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })
    this.Borc.Masraf = null


  }

  function filtrekayit() {
    this.renk1 = 'orange darken-4'
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.renk1 = 'info'
    this.dialogfiltre = false


  }

  function getList() {
     if (this.$refs.formtarih.validate()) {

        this.progress = true
        this.grandDebt = 0
        this.dueDebt = 0

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Borc.SirketKodu = '0'
        } else {
          this.Borc.SirketKodu = credentials.SirketKodu
        }

        this.Borc.Tarih = this.date



        var params = this.Borc

        this.load1 = false
        this.$http.post(auth.API_URL + 'api/Report/DebitorList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
          if (response.body.length > 0) {
            this.grandDebt = response.body[0].GrandDebt.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
            this.dueDebt = response.body[0].DueDebt.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          }
          this.progress = false
          this.load1 = true
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false


          }
        })


      }



  }


  function getListHtml() {
    this.progress = true
    this.grandDebt = 0
    this.dueDebt = 0



    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.tumsirketler === true) {
      this.Borc.SirketKodu = '0'
    } else {
      this.Borc.SirketKodu = credentials.SirketKodu
    }

    this.Borc.Tarih = this.date

    if (this.a === true) {
      this.Borc.Sira = '0'
    } else if (this.b === true) {
      this.Borc.Sira = '1'
    }

    var params = this.Borc

    this.load1 = false
    this.$http
      .post(auth.API_URL + "api/Report/DebitorListHtml", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/html'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "BorcluListesi.html";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false


        }
      })
  }

  function getListExcel() {
    this.progress = true
    this.grandDebt = 0
    this.dueDebt = 0



    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.tumsirketler === true) {
      this.Borc.SirketKodu = '0'
    } else {
      this.Borc.SirketKodu = credentials.SirketKodu
    }

    this.Borc.Tarih = this.date

    if (this.a === true) {
      this.Borc.Sira = '0'
    } else if (this.b === true) {
      this.Borc.Sira = '1'
    }

    var params = this.Borc

    this.load1 = false
    this.$http
      .post(auth.API_URL + "api/Report/DebitorListExcel", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        },responseType: "arraybuffer"
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/xlsx'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "BorcluListesi.xlsx";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false


        }
      })
  }

  function beforeMount() {
    this.progress = true
    this.load1 = false
    this.date = helpers.getDateNow()

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params = {
      CompanyCode: credentials.SirketKodu,
      StartDate: this.date,
      StartCurrentCode: this.Cari1,
      EndCurrentCode: this.Cari2
    }
    this.$http.post(auth.API_URL + 'api/Report/DebitorList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body
      this.grandDebt = response.body[0].GrandDebt.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      this.dueDebt = response.body[0].DueDebt.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      this.progress = false
      this.load1 = true


    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true

      }
    })
  }

  function carigetir(v) {
    if (v.length >= 0) {
      this.loading1 = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading1 = false
      }, 500)
    }
  }

  function carigetir1(v) {
    if (v.length >= 0) {
      this.loading2 = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari2 = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.Success = false
            this.Error = 'Service Unavailable'
          } else {
            this.Success = false
            this.Error = response.statusText
          }
        })
        this.loading2 = false
      }, 500)
    }
  }



  function onChange(v) {
    var c = v.length
    var a = v
    if (c == 8) {
      var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]
      var ay = a[2] + a[3]
      var gun = a[0] + a[1]
      var yil = a[4] + a[5] + a[6] + a[7]

      a = new Date(b)

      if (a instanceof Date && !isNaN(a.valueOf())) {
        //şubatın 29 çekmesin
        if (ay == '02' && yil % 10 != 0 && gun == '29') {

          b = yil + '-' + ay + '-' + '28'
          this.date = b
          this.dateFormatted = '28' + '-' + ay + '-' + yil
          //31 nisan
        } else if (ay == '04' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 haziran
        } else if (ay == '06' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 eylül
        } else if (ay == '09' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 kasım
        } else if (ay == '11' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil

        } else {
          this.date = b
        }
      } else {
        this.dateFormatted = null

      }
    } else {
      this.dateFormatted = null
    }
  }


  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }


  function getDateNow1() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '.' + mm + '.' + yyyy
    return today
  }
</script>
<style>
  /* @import '../../../assets/css/custom.css'; */
</style>